<template>
  <main-layout>
    <b-row>
      <b-col
        class="shadow-sm"
        style
      >
        <b-card-body>
          <h4 class="card-title font-weight-bold">
            Verstösse Gesetzliche Mindestlöhne
          </h4>

          <v-btn
            color="success"
            @click="startApplicationValidation"
          >
            Prüfung starten
          </v-btn>

          <v-flex
            v-if="isLoading"
            justify-center
          >
            <u-loader />
          </v-flex>

          <v-data-table
            v-else
            :headers="headers"
            :items="$store.state.mindestLohnKonfiguration.AggregatedStates"
            :rows-per-page-items="rowsPageItems"
            class="elevation-1 mt-4"
            no-data-text="Momentan keine Mindestlohnverstösse vorhanden"
            no-results-text="Momentan keine Mindestlohnverstösse vorhanden"
            rows-per-page-text="Resultate pro Seite"
          >
            <template v-slot:items="props">
              <td>
                <router-link :to="getMindestlohnValidationLink(props.item)">
                  {{ props.item.contractNumber }}
                </router-link>
              </td>
              <td>
                <router-link :to="getMindestlohnValidationLink(props.item)">
                  {{ props.item.versionNumber }}
                </router-link>
              </td>
              <td>
                <router-link :to="getMindestlohnValidationLink(props.item)">
                  {{ props.item.editionId }}
                </router-link>
              </td>
              <td>
                <router-link :to="getMindestlohnValidationLink(props.item)">
                  {{ props.item.violationsCount }}
                </router-link>
              </td>
              <td>
                <p>{{ getMinimalSalaryValidationState(props.item.state) }}</p>
              </td>
              <td>
                <p>
                  {{ getMinimalSalaryPredictionState(props.item.prediction) }}
                </p>
              </td>
              <td>
                <b-col class="py-2">
                  <div
                    v-for="(tenant, tenantIndex) in allTenants"
                    :key="tenantIndex"
                  >
                    <b-check
                      :checked="CheckIfTenantIsChecked(tenant, props.item)"
                      :disabled="true"
                    >
                      {{ tenant.bezeichnung }}
                    </b-check>
                  </div>
                </b-col>
              </td>
            </template>
          </v-data-table>
        </b-card-body>
      </b-col>
    </b-row>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import {
  GetMinimalsalaryvalidationstates,
  GetMinimalsalarypredictionstates,
  StartApplicationCantonalMinimumWageValidation,
} from "@/services/minimum.wage.services/canton.minimum.wages";

export default {
  components: {
    MainLayout,
  },
  data() {
    return {
      rowsPageItems: [25, 50, 100, { text: "Alle", value: -1 }],
      headers: [
        { text: "Vertrag", value: "contractNumber", align: "left" },
        { text: "Version", value: "versionNumber", align: "left" },
        { text: "Edition", value: "editionId", align: "left" },
        { text: "Anzahl Verstösse", value: "violationsCount", align: "left" },
        { text: "Fehlertyp", value: "state", align: "left" },
        { text: "Prognose", value: "prediction", align: "left" },
        { text: "Tenants", value: "tenants", align: "left" },
      ],
      aggregatedStates: [],
      allTenants: [
        {
          Id: 1,
          bezeichnung: "gav-service.ch",
        },
        {
          Id: 2,
          bezeichnung: "tempdata.ch",
        },
        {
          Id: 3,
          bezeichnung: "seco",
        },
        {
          Id: 4,
          bezeichnung: "Unia",
        },
      ],
      minimalSalaryValidationStates: [],
      minimalSalaryPredictionStates: [],
      isLoading: false,
    };
  },

  created() {
    this.isLoading = true;
    this.loadMinimalsalaryvalidationstates();
    this.loadMinimalsalarypredictionstates();
  },
  methods: {
    startApplicationValidation() {
      StartApplicationCantonalMinimumWageValidation(
        () => {
          this.loadStatus(true);
        },
        (error) => {
          this.errorObject = error;
        },
      );
    },
    getMinimalSalaryValidationState(state) {
      if (state && this.minimalSalaryValidationStates) {
        return this.minimalSalaryValidationStates[state];
      } else {
        return "-";
      }
    },
    getMinimalSalaryPredictionState(state) {
      if (state && this.minimalSalaryPredictionStates) {
        return this.minimalSalaryPredictionStates[state];
      } else {
        return "-";
      }
    },

    loadMinimalsalaryvalidationstates() {
      GetMinimalsalaryvalidationstates(
        (response) => {
          this.minimalSalaryValidationStates = response;
          setTimeout(() => {
            this.isLoading = false;
          }, 100);
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    loadMinimalsalarypredictionstates() {
      GetMinimalsalarypredictionstates(
        (response) => {
          this.minimalSalaryPredictionStates = response;
          setTimeout(() => {
            this.isLoading = false;
          }, 100);
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    getMindestlohnValidationLink(item) {
      return `contract-overview/${item.contractNumber}/${item.versionNumber}/${
        item.configurationId
      }/mindestlohnkonfiguration/validierung`;
    },
    CheckIfTenantIsChecked(tenant, state) {
      let isChecked = false;
      if (state && state.tenants && state.tenants.length > 0) {
        isChecked = state.tenants.some((x) => x == tenant.Id);
      }

      return isChecked;
    },
  },
};
</script>

<style>
.vue-fixed-header--isFixed {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  opacity: 0;
  animation: fadeIn 0.3s ease-out forwards;
}

.contractOverViewTabControl .shadow-sm {
  border-top: none;
  border-radius: 0px;
}

.contractOverViewTabControl {
  width: 100%;
}

.tab-pane {
  outline: none !important;
}
</style>

<style scoped>
.fixedHeader {
  z-index: 50;
  top: 0px;
  background-color: rgb(74, 74, 74);
  color: white;
  padding: 15px;
  margin-left: -14px;
  max-width: 1120px;
  width: 100%;
  border: 1px solid rgb(202, 202, 202);
}

@media (max-width: 1904px) {
  .fixedHeader {
    max-width: 1074px;
  }
}

@media (max-width: 1199px) {
  .fixedHeader {
    max-width: 894px;
  }
}

@media (max-width: 992px) {
  .fixedHeader {
    max-width: 654px;
  }
}
</style>
